// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence" formulaire="vm.monoOccurrenceOptions.formulaire" largeur-formulaire="100"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;